import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { StorageMap } from "@ngx-pwa/local-storage";
import * as moment from "moment";
import { User } from "src/app/shared/models/user.model";
import { LocalDataStoreService } from "./local-data-store.service";

@Injectable({
	providedIn: "root",
})
export class GuardService implements CanActivate {
	moment: any = moment;

	constructor(private localStore: LocalDataStoreService, private storage: StorageMap, private router: Router) {}

	async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const user: User = await this.localStore.get("user");

		if (user && moment.unix(user.expiration).isBefore()) {
			console.log(`Session expired at ${moment.unix(user.expiration).format()}`);
			console.log("Expired session");
			this.router.navigateByUrl("/login");
			return false;
		}
		return true;
	}
}
